'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import ContentRoutes from 'ContentUtils/Routes';
import { USED_IN_LIST } from '../actions/ActionTypes';
import { closeModal } from '../actions/ModalActions';
import { requestedUseInListFailure, requestedUseInListSuccess, requestUseInList } from '../actions/ListsActions';
export default ((action$, _, {
  ListsClient
}) => action$.ofType(USED_IN_LIST).pipe(mergeMap(({
  payload: {
    contentType,
    data,
    listId
  }
}) => ListsClient.exportToList(data, listId).pipe(mergeMap(() => of(closeModal(), requestedUseInListSuccess(contentType, ContentRoutes.list(listId)))), catchError(error => of(requestedUseInListFailure(error, contentType))), startWith(requestUseInList())))));